// extracted by mini-css-extract-plugin
export default {"root":"CarouselModal-module-root-MQvvq","spinner":"CarouselModal-module-spinner-fwNYF"};